/* VH Why Vital Health (sections/vh-why.liquid). PRESENTATION ONLY: no cart, customer or network calls.
   Savings calculator: every price comes from the section's data-* attributes (Shopify variant + selling plan prices, in cents).
   Motion (2026-10-07): hero word rise + parallax, scroll-lit statement, fact count-ups, card tilt, photo-card reveals, closing
   parallax. All of it starts from content that is already visible, and none of it runs with prefers-reduced-motion. */
(function () {
  var root = document.getElementById('vh-why');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Shopify money format (shop.money_format), trailing .00 dropped like money_without_trailing_zeros */
  var FMT = root.getAttribute('data-money-format') || '${{amount}}';
  var CUR = String(root.getAttribute('data-currency') || '').toUpperCase();
  function money(cents) {
    var n = Math.round(cents) / 100;
    var whole = Math.round(cents) % 100 === 0;
    var group = function (x, d, t, s) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); };
    var out = FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, whole ? 0 : 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      return group(n, whole ? 0 : 2, ',', '.');
    });
    /* currency code after every amount (Mexico: "$ 500 MXN") so no price reads as US dollars */
    return out.replace(/<[^>]*>/g, '') + (CUR ? ' ' + CUR : '');
  }

  /* number tween (rAF, ease-out); fmt turns the running value into text */
  function tween(el, from, to, ms, fmt) {
    if (RM || from === to) { el.textContent = fmt(to); return; }
    var t0 = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - t0) / ms), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* Shopping rewards: mirrors MARKET in assets/retail-reward-bar.v3.js L11-18 (USD thresholds x catalog rate, low to high).
     One-time orders only; Autoship, packs and the membership void it there too. */
  var MARKET = {
    USD: {rate: 1, tiers: [{min: 300, rate: 0, ship: true}]},
    MXN: {rate: 18, tiers: [{min: 200, rate: 10, ship: false}, {min: 250, rate: 25, ship: false}, {min: 300, rate: 25, ship: true}]}
  };
  var market = MARKET[String(root.getAttribute('data-currency') || '').toUpperCase()] || null;
  function rewardRate(cents) {
    if (!market) return 0;
    var r = 0;
    market.tiers.forEach(function (t) { if (cents >= t.min * market.rate * 100) r = t.rate; });
    return r;
  }

  var bars = $('.vh-why-bars');
  var picks = $$('.vh-why-pick');
  var fee = +root.getAttribute('data-membership') || 0;
  var T = function (k) { return bars ? bars.getAttribute('data-t-' + k) || '' : ''; };
  var packUrl = bars ? bars.getAttribute('data-pack-url') || '' : '';
  var prev = [];

  function bar(label, v, max, color, sub) {
    return '<div class="vh-why-bar"><div class="vh-why-t"><span>' + esc(label) + (sub ? ' <small>' + esc(sub) + '</small>' : '') + '</span><b data-v="' + v + '">' + esc(money(v)) + '</b></div>' +
      '<div class="vh-why-tr"><i style="width:' + (v / max * 100).toFixed(2) + '%;background:' + color + '"></i></div></div>';
  }

  function calc() {
    if (!bars) return;
    var on = picks.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    var note = $('.vh-why-note', bars);
    var noteHTML = note ? note.outerHTML : '';
    if (!on.length) { bars.innerHTML = '<h3>' + esc(T('pick')) + '</h3>' + noteHTML; prev = []; return; }
    var sum = function (k) { return on.reduce(function (a, b) { return a + (+b.getAttribute('data-' + k) || 0); }, 0); };
    var retail = sum('c'), auto = sum('a'), mem = sum('m');
    var pct = +(on[0].getAttribute('data-pct') || 0);
    var same = on.every(function (b) { return +(b.getAttribute('data-pct') || 0) === pct; });
    var rr = rewardRate(retail), retailNet = Math.round(retail * (1 - rr / 100));
    var max = Math.max(retail, 1), save = retail - mem, months = save > 0 && fee > 0 ? Math.ceil(fee / save) : null;
    var head = on.length === 1 ? T('one') : T('many').replace('[n]', on.length);
    var cover = months ? ' ' + (months === 1 ? T('cover1') : T('cover').replace('[n]', months)).replace('[fee]', money(fee)) : '';
    var saveTxt = esc(T('save')).replace('[x]', '<b data-v="' + save + '">' + esc(money(save)) + '</b>');
    bars.innerHTML = '<h3>' + esc(head) + '</h3>' +
      bar(T('retail'), retailNet, max, '#a9a28c', rr ? T('reward').replace('[p]', rr) : '') +
      bar(T('auto'), auto, max, '#53a43f', same && pct ? '(−' + pct + '%)' : '') +
      bar(T('member'), mem, max, '#053d2b', '') +
      (save > 0 ? '<div class="vh-why-save">' + saveTxt + esc(cover) + '</div>' : '') +
      /* guests and customers: the membership comes with every Welcome Pack (link = the business button's: the wizard) */
      (packUrl && T('pack') ? '<a class="vh-why-plink" href="' + esc(packUrl) + '">' + esc(T('pack')) + ' <span aria-hidden="true">→</span></a>' : '') + noteHTML;
    /* totals count from the previous order to this one */
    var now = $$('b[data-v]', bars);
    now.forEach(function (b, i) {
      var to = +b.getAttribute('data-v');
      if (prev[i] != null) tween(b, prev[i], to, 600, money);
    });
    prev = now.map(function (b) { return +b.getAttribute('data-v'); });
  }

  picks.forEach(function (b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      calc();
    });
  });
  calc();

  /* fact strip: count up once when it comes into view (decimals kept, e.g. 32.5) */
  var facts = $$('.vh-why-fact b[data-count]');
  if (facts.length && !RM && 'IntersectionObserver' in window) {
    var fio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        fio.unobserve(e.target);
        var raw = String(e.target.getAttribute('data-count')).replace(/[^\d.]/g, '');
        var to = parseFloat(raw) || 0, dec = (raw.split('.')[1] || '').length;
        /* keep what follows the number ("30+", "32.5%") */
        var suf = e.target.getAttribute('data-suffix') || String(e.target.getAttribute('data-count')).replace(/^[\d.,\s]*/, '');
        tween(e.target, 0, to, 1400, function (v) { return v.toFixed(dec) + suf; });
      });
    }, {threshold: 0.6});
    facts.forEach(function (b) { fio.observe(b); });
  }

  /* card tilt + glare: desktop pointers only; writes go to the card itself (never <html>), one per frame */
  if (!RM && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $$('[data-tilt]').forEach(function (card) {
      var raf = 0, px = 0, py = 0;
      function apply() {
        raf = 0;
        var r = card.getBoundingClientRect();
        var x = (px - r.left) / r.width, y = (py - r.top) / r.height;
        card.style.setProperty('--ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * 6).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      }
      card.addEventListener('pointerenter', function () { card.classList.add('is-tilt'); });
      card.addEventListener('pointermove', function (e) { px = e.clientX; py = e.clientY; if (!raf) raf = requestAnimationFrame(apply); });
      card.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf), raf = 0;
        card.classList.remove('is-tilt');
        card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      });
    });
  }

  if (window.VHK) {
    VHK.reveals(root);
    VHK.withGsap(function (ok) {
      if (!ok) return;
      var hero = $('.vh-why-hero');
      /* hero: words rise out of their line masks, then the rest; the photo settles and drifts slower than the page */
      gsap.from($$('.vh-why-w > span'), {yPercent: 115, duration: 1.15, stagger: 0.07, ease: 'power4.out', delay: 0.1});
      gsap.from([$('.vh-why-hk'), $('.vh-why-lede'), $('.vh-why-chips')], {autoAlpha: 0, y: 26, duration: 0.9, stagger: 0.1, delay: 0.55, ease: 'power3.out'});
      gsap.fromTo($('.vh-why-hero-bg img'), {scale: 1.14}, {scale: 1, duration: 2.4, ease: 'power2.out'});
      gsap.to($('.vh-why-hero-bg'), {yPercent: 14, ease: 'none', scrollTrigger: {trigger: hero, start: 'top top', end: 'bottom top', scrub: true}});
      gsap.to($('.vh-why-hero-in'), {autoAlpha: 0.15, y: -60, ease: 'none', scrollTrigger: {trigger: hero, start: '40% top', end: 'bottom top', scrub: true}});

      /* statement: each word lights up as it scrolls through the middle of the screen */
      var words = $$('.vh-why-mw');
      if (words.length) {
        gsap.fromTo(words, {opacity: 0.14}, {opacity: 1, stagger: 0.1, ease: 'none',
          scrollTrigger: {trigger: $('.vh-why-mtext'), start: 'top 82%', end: 'bottom 48%', scrub: true}});
      }

      /* support photos open from a smaller rounded window as they arrive */
      $$('.vh-why-xi').forEach(function (el, i) {
        gsap.fromTo(el, {clipPath: 'inset(14% 10% 14% 10% round 26px)'}, {clipPath: 'inset(0% 0% 0% 0% round 26px)', ease: 'none',
          scrollTrigger: {trigger: el, start: 'top 95%', end: 'top 45%', scrub: true}});
        gsap.from(el.parentNode.querySelector('.vh-why-xt'), {autoAlpha: 0, y: 30, duration: 0.9, delay: i * 0.08, ease: 'power3.out',
          scrollTrigger: {trigger: el, start: 'top 75%', once: true}});
      });

      /* closing scene drifts against the scroll */
      var fin = $('.vh-why-fin');
      if (fin) gsap.fromTo($('.vh-why-fin-bg'), {yPercent: -8}, {yPercent: 8, ease: 'none', scrollTrigger: {trigger: fin, start: 'top bottom', end: 'bottom top', scrub: true}});

      VHK.refresh();
    });
  }
})();
